module.exports = __webpack_public_path__ + "img/grab_controllers.0fe90412.png";